var exports = {
  "k": "xfd349460--1757f0--container",
  "V": "xfd349460--1757f0--preview",
};

module.exports = exports;
